import React from 'react'
// https://react-icons.github.io/react-icons/
import {
    FaYoutube,
    FaFacebookSquare,
    FaInstagramSquare,
    FaBandcamp
} from 'react-icons/fa'
import texture from '../images/TextureBlue060C1D.png'
import logo from '../images/CTS_Class_Equation_Transparent.png'

const Footer = () => {
    return (
        <div className='h-auto'>
            <div className='flex min-h-full flex-col'>
                <div className='w-full flex-1 mx-auto text-[#cdc3b9] h-200 py-8 px-4' style={{ backgroundImage: `url(${texture})`, backgroundRepeat: 'repeat' }}>
                    <div className='flex justify-center mb-2'>
                        <img src={logo} alt="Chance to Steal" style={{ width: '100px', height: '100px', objectFit: 'contain' }} />
                    </div>
                    <div className='flex justify-center mb-2'>
                        <div className='grid grid-cols-4 mx-4'>
                            <div className='w-[40px] flex justify-center'><a className='transition-all duration-300 hover:drop-shadow-[0_0_8px_rgba(156,52,214,0.9)] hover:text-white' href="https://www.facebook.com/chancetosteal"><FaFacebookSquare size={30} /></a></div>
                            <div className='w-[40px] flex justify-center'><a className='transition-all duration-300 hover:drop-shadow-[0_0_8px_rgba(156,52,214,0.9)] hover:text-white' href="https://www.instagram.com/chancetosteal"><FaInstagramSquare size={30} /></a></div>
                            <div className='w-[40px] flex justify-center'><a className='transition-all duration-300 hover:drop-shadow-[0_0_8px_rgba(156,52,214,0.9)] hover:text-white' href="https://www.youtube.com/@chancetosteal"><FaYoutube size={30} /></a></div>
                            <div className='w-[40px] flex justify-center'><a className='transition-all duration-300 hover:drop-shadow-[0_0_8px_rgba(156,52,214,0.9)] hover:text-white' href="https://chancetosteal.bandcamp.com"><FaBandcamp size={30} /></a></div>
                        </div>
                    </div>
                    <div className='flex justify-center'>
                        <p className='text-sm'>Copyright 2026 - Chance to Steal</p>
                    </div>
                </div >
            </div>

        </div>

    )
}

export default Footer